// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch-switch-9545","input":"Switch-input-9545","slider":"Switch-slider-9545","checked":"Switch-checked-9545","disabled":"Switch-disabled-9545"};